<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Nova Anotação' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <form class="sample-form validations-form" [formGroup]="validations_form"
    (ngSubmit)="onSubmit(validations_form.value)">
    <div class="gradient-extendido"></div>

    <div class="remove-border remove-card">
      <ion-card-content>
        <ion-list>
          <ion-item class="switcher-item">
            <ion-label
              position="stacked"
              style="font-size: 14px; font-weight: bold"
            >
              {{'Descrição da Anotação' | translate}}
              <span class="danger">*</span>
            </ion-label>

            <ion-textarea
              rows="5"
              type="text"
              formControlName="anotacao"
              placeholder="{{'Descrição' | translate}}"
              style="font-size: 13px"
            ></ion-textarea>
          </ion-item>

          <div class="validation-errors">
            <ng-container
              *ngFor="let validation of validation_messages.anotacao"
            >
              <div
                class="error-message"
                *ngIf="
                  validations_form.get('anotacao')?.hasError(validation.type) &&
                  (validations_form.get('anotacao')?.dirty ||
                  validations_form.get('anotacao')?.touched)
                "
              >
                {{ validation.message }}
              </div>
            </ng-container>
          </div>

          <div class="down">
            <ion-button
              expand="block"
              class="btn-success"
              type="submit"
              [disabled]="!validations_form.valid"
            >
              {{'Salvar' | translate}}
            </ion-button>
          </div>
        </ion-list>
      </ion-card-content>
    </div>
  </form>
</ion-content>